import React from 'react'

export default function FeaturedRibbon() {
  return (
    <div className='w-full bg-[#D4E4EA] flex flex-col justify-center items-center'>
      <div className="w-full  mx-auto max-w-7xl bg-[#D4E4EA] self-stretch py-6 inline-flex flex-col justify-start items-center gap-6 md:gap-10">
        <div className="self-stretch text-center justify-start text-blue-950 text-sm md:text-base font-semibold font-['Instrument-Sans'] uppercase tracking-wide">
          As Featured In
        </div>
        {/* Desktop Layout */}
        <div className="hidden md:flex self-stretch inline-flex justify-center items-center gap-14">


          <img
            className="w-32 h-16 object-contain"
            src="/static/images/cka_landing/img-logo-AFI-FAmagazine-400x200.png"
            alt="FA Magazine"
          />
          <img
            className="w-32 h-16 object-contain"
            src="/static/images/cka_landing/faithfi-black.png"
            alt="FaithFi"
          />
          <img
            className="w-32 h-16 object-contain"
            src="/static/images/cka_landing/img-logo-AFI-WallStreetJournal-400x200.png"
            alt="Wall Street Journal"
          />
          <img
            className="w-32 h-16 object-contain"
            src="/static/images/cka_landing/img-logo-AFI-Barrons-400x200.png"
            alt="Barrons"
          />
          <img
            className="w-40 h-16 object-contain"
            src="/static/images/cka_landing/img-logo-AFI-ChristianPost-400x200.png"
            alt="The Christian Post"
          />

          <img
            className="w-32 h-16 object-contain"
            src="/static/images/cka_landing/img-logo-AFI-Yahoo-400x200.png"
            alt="Yahoo Finance"
          />

        </div>

        {/* Mobile Layout - 2 rows of 3 logos each */}
        <div className="md:hidden flex flex-col gap-6 w-full">
          {/* First row */}
          <div className="flex justify-center items-center gap-6">
            <img
              className="w-24 h-12 object-contain"
              src="/static/images/cka_landing/img-logo-AFI-Barrons-400x200.png"
              alt="Barrons"
            />
            <img
              className="w-28 h-12 object-contain"
              src="/static/images/cka_landing/img-logo-AFI-ChristianPost-400x200.png"
              alt="The Christian Post"
            />
            <img
              className="w-24 h-12 object-contain"
              src="/static/images/cka_landing/img-logo-AFI-FAmagazine-400x200.png"
              alt="FA Magazine"
            />
          </div>

          {/* Second row */}
          <div className="flex justify-center items-center gap-6">
            <img
              className="w-24 h-12 object-contain"
              src="/static/images/cka_landing/img-logo-AFI-WallStreetJournal-400x200.png"
              alt="Wall Street Journal"
            />
            <img
              className="w-24 h-12 object-contain"
              src="/static/images/cka_landing/img-logo-AFI-Yahoo-400x200.png"
              alt="Yahoo Finance"
            />
            <img
              className="w-24 h-12 object-contain"
              src="/static/images/cka_landing/faithfi-black.png"
              alt="FaithFi"
            />
          </div>
        </div>
      </div>
    </div>
  )




}